import { ISiteConfigLayouts, SportsbookLayoutEnum } from "@finbackoffice/fe-core";
import { useSiteConfig } from "./useSiteConfig";

export const useSportsbookConfig = () => {
    const sportsbookConfig = useSiteConfig<ISiteConfigLayouts>("layouts").sportsbook;

    const isSportsbookFlat = sportsbookConfig.type === SportsbookLayoutEnum.Flat;

    return { isSportsbookFlat };
};
